module.exports = __webpack_public_path__ + "static/img/down_btn10.0b817f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/down_btn10.png
// module id = FILW
// module chunks = 4